<template>
  <div style="padding: 10px 15px; width: 100%; height: 92%;">
    <div style="position :relative;">
      <a-menu :selectedKeys="[$route.path]" mode="horizontal" style="border-bottom: 0; margin-bottom: 20px; position: relative;">
      <!-- <a-menu-item key="/overview/charts" @click="$router.push('/overview/charts')"> <a-icon type="pie-chart" />图表</a-menu-item> -->
        <a-menu-item v-for="(a, i) in authorities" :key="menuMap[a.code].path" @click="handleMenuClick(a, i)"> <a-icon :type="menuMap[a.code].icon" />{{ $t(`overview.${menuMap[a.code].field}`) }}</a-menu-item>
      </a-menu>
      <div class="fullscreen_btn">
        <a-button type="primary" @click="zoomIn" style="margin-right: 15px;">{{ $t('buttons.zoomIn') }}</a-button>
        <a-button type="primary" @click="s">{{ $t('buttons.fullscreen') }}</a-button>
      </div>
    </div>
    <div class="w-100 h-100 container" ref="f">
      <div style="height: 30px; position: absolute; z-index: 10; left: 0; right: 0; transform: translateY(20px);">
        <div class="svgs" v-if="isArrowsShow" style="float: right;">
          <svg @click="goBackward" style="margin-right: -20px;" t="1751610347433" viewBox="0 0 1027 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1749" width="60" height="30"><path d="M598.361605 38.378364v198.288215H962.956065c38.378364 0 63.96394 25.585576 63.96394 63.963941v422.162006c0 38.378364-25.585576 63.96394-63.96394 63.96394H598.361605v198.288215c0 6.396394-6.396394 19.189182-12.792788 25.585576-12.792788 12.792788-38.378364 19.189182-51.171152 6.396394l-511.711523-454.143976-6.396394-6.396394c-25.585576-25.585576-19.189182-63.96394 6.396394-89.549517l511.711523-454.143976c12.792788-6.396394 19.189182-12.792788 25.585576-12.792788 25.585576 0 38.378364 19.189182 38.378364 38.378364z" p-id="1750"></path></svg>
          <svg @click="goForward" t="1751608233199" viewBox="0 0 1027 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1468" width="60" height="30"><path d="M466.052637 0c6.384283 0 12.768565 6.384283 25.53713 12.768565l510.742616 453.284072c25.537131 25.537131 31.921413 63.842827 6.384283 89.379957l-6.384283 6.384283-510.742616 453.284071c-12.768565 12.768565-38.305696 12.768565-51.074261-6.384282-6.384283-6.384283-12.768565-19.152848-12.768565-25.537131v-197.912764H63.842827c-38.305696 0-63.842827-25.537131-63.842827-63.842827V300.061287c0-38.305696 25.537131-63.842827 63.842827-63.842827h363.904114V38.305696c0-19.152848 12.768565-38.305696 38.305696-38.305696z" p-id="1469"></path></svg>
        </div>
      </div>
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: 'overview',
  created() {
    this.authorities = this.getAuthorities('/overview')
  },
  mounted () {
    // compressorApi.getStatistics().then(({ data }) => {
    //   this.statistics = data
    // }).catch(() => {
    //   this.$message.error('请求异常', 1)
    // })
    document.addEventListener('fullscreenchange', this.handleFullscreenChange)
    if (this.$route.path.endsWith('list')) {
      this.$refs.f.style.overflowY = 'auto'
    }
    if (this.$route.path === '/overview') {
      this.$router.replace(this.menuMap[this.authorities[this.currentAuthIndex].code].path)
    }
    const i = this.authorities.findIndex(a => this.$route.path === this.menuMap[a.code].path)
    if (i >= 0) {
      this.currentAuthIndex = i
    }
  },
  updated() {
    if (this.$route.path === '/overview') {
      this.$router.replace(this.menuMap[this.authorities[this.currentAuthIndex].code].path)
    }
  },
  data () {
    return {
      colMd: 6,
      statistics: {
        running: 0,
        standby: 0,
        fault: 0,
        withoutElectricity: 0,
        maintain: 0
      },
      menuMap: {
        'data:screen:service': {
          title: '服务',
          path: '/overview/service',
          icon: 'pie-chart',
          field: 'service'
        },
        'data:screen:monitor': {
          title: '监控',
          path: '/overview/monitor',
          icon: 'pie-chart',
          field: 'monitor'
        },
        'data:screen:warning': {
          title: '预警',
          path: '/overview/list',
          icon: 'database',
          field: 'list'
        },
        "data:screen:bigData": {
          title: "大数据监测",
          path: "/overview/bigData",
          icon: "database",
          field: "bigData"
        }
      },
      authorities: [],
      isFullScreen: false,
      currentAuthIndex: 0
    }
  },
  computed: {
    isArrowsShow() {
      return this.isFullScreen && this.authorities.length > 1
    }
  },
  methods: {
    s () {
      this.$refs.f.requestFullscreen()
    },
    handleFullscreenChange () {
      const f = this.$refs.f
      const isFullScreen = document.fullscreenElement !== null
      this.isFullScreen = isFullScreen
      if (this.$route.path.endsWith('charts')) {
        if(isFullScreen) {
          if(window.innerWidth * 1080 / 1920 > window.innerHeight) {
            f.style.height = window.innerHeight + "px"
            f.style.overflow = 'hidden auto'
          } else {
            f.style.height = window.innerWidth * 1080 / 1920 + "px"
            f.style.overflow = "unset"
          }
        } else {
          f.style.height = 'unset'
          f.style.overflow = 'hidden'
        }
      }
      if (this.$route.path.endsWith('list')) {
        const c = document.querySelector('content')
      }
    },
    goBackward() {
      if (--this.currentAuthIndex < 0) {
        this.currentAuthIndex = this.authorities.length - 1
      }
      this.$router.push(this.menuMap[this.authorities[this.currentAuthIndex].code].path)
    },
    goForward() {
      if (++this.currentAuthIndex === this.authorities.length) {
        this.currentAuthIndex = 0
      }
      this.$router.push(this.menuMap[this.authorities[this.currentAuthIndex].code].path)
    },
    handleMenuClick(a, i) {
      this.currentAuthIndex = i
      this.$router.push(this.menuMap[a.code].path)
    },
    zoomIn() {
      let path = this.menuMap[this.authorities[this.currentAuthIndex].code].path
      path = path.replace("overview", "fullscreen")
      this.$router.push(path)
    }
  }
}
</script>

<style lang="less" scoped>
  .col-mb {
    margin-bottom: 10px;
  }
  .info-icon {
    float: right;
    color: #1890ff;
  }
  .fullscreen_btn {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
  }
  .container {
    position: relative;
    &::-webkit-scrollbar {  /*滚动条整体样式*/
      width: 4px;           /*高宽分别对应横竖滚动条的尺寸*/
      height: 4px;
    }
    &::-webkit-scrollbar-thumb {  /*滚动条滑块*/
      border-radius: 5px;
      background-color: #4961A3;
    }
    &::-webkit-scrollbar-track {  /*滚动条轨道*/
      border-radius: 0;
      background: rgba(0,0,0,0.1);
    }
  }
  .svgs {
    cursor: pointer;
    path {
      fill: transparent;
    }
    &:hover {
      path {
        fill: #fff;
      }
    }
  }
</style>
